import React from 'react';
import { Table, Button, Space, Popconfirm, Skeleton, Tooltip } from 'antd';
import { DeleteOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';

const PassTable = ({ passes, loading, openPopup, userRole, handleDeletePass }) => {
    const location = useLocation();
    const buttonText = location.pathname === '/buy-passes' ? 'Add to Cart' : 'Add to Invoice';

    const columns = [
        {
            title: 'Day',
            dataIndex: 'day',
            key: 'day',
        },
        {
            title: 'Type',
            dataIndex: 'type',
            key: 'type',
        },
        {
            title: 'Price',
            dataIndex: 'price',
            key: 'price',
            render: (text) => text === 0 ? 'Free' : `R ${text}`,
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (text, record) => (
                <Space>
                    {userRole === 'admin' ? (
                        <Space>
                            <Button onClick={() => openPopup(record)}>Edit</Button>
                            <Popconfirm
                                title="Are you sure you want to delete this pass?"
                                onConfirm={() => handleDeletePass(record._id)}
                                okText="Yes"
                                cancelText="No"
                            >
                                <Tooltip title="Delete Pass">
                                    <Button danger icon={<DeleteOutlined />} shape='circle' type='text' />
                                </Tooltip>
                            </Popconfirm>
                        </Space>
                    ) : (
                        <Button
                            type="primary"
                            icon={<ShoppingCartOutlined />}
                            onClick={() => openPopup(record)}
                            style={{
                                backgroundColor: '#1890ff',
                                borderColor: '#1890ff',
                                color: '#fff'
                            }}
                        >
                            {buttonText}
                        </Button>
                    )}
                </Space>
            ),
        }
    ];

    return (
        <>
            {loading ? (
                <Skeleton active />
            ) : (
                <Table
                    dataSource={passes}
                    columns={columns}
                    rowKey="_id"
                    scroll={{ x: true }}
                    pagination={{
                        hideOnSinglePage: true,
                        pageSize: 100
                    }}
                />
            )}
        </>
    );
};

export default PassTable;  
